



























































































































































































import Vue from 'vue';
import {
  Component, Inject, Provide, Watch,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import {
  KCardHeader, KCardHeaderBtn,
} from '@kasasa/fbase-components';
import {
  Alert, NoticeClass, AuthStore, Dialog,
} from '@kasasa/fbase-components/lib';
import { Cycle, CycleResource } from '@/api/cycles';
import CycleSelect from '@/components/cycles/CycleSelect.vue';
import CycleValidationResultCard from '@/components/rewardsvalidation/CycleValidationResultCard.vue';
import PostingFilesCard from '@/components/rewardsvalidation/PostingFilesCard.vue';
import ValidationApprovalSection from '@/components/rewardsvalidation/ValidationApprovalSection.vue';
import TransactionCountCard from '@/components/rewardsvalidation/TransactionCountCard.vue';
import EOCDataPointsCard from '@/components/rewardsvalidation/EOCDataPointsCard.vue';
import {
  RewardsValidationResource, PostingFileResource, SweepFileResource,
  CycleValidationSnapshot, ValidationProduct, CycleReportExistsResult, CycleValidationPostingFile,
  SweepFileApprovalResource, SnapshotApprovalResource, ValidationSnapshot, CycleTransactionCount,
  NonTransactionDataSnapshot, CycleApprovalState, CycleValidationReportFile,
} from '@/api/rewardsvalidation/';

interface Approval {
  approvalState: string,
  approverName: string,
  approvalTime: string
}

@Component({
  computed: mapState([
    'fiId',
  ]),
  components: {
    KCardHeader,
    KCardHeaderBtn,
    CycleSelect,
    CycleValidationResultCard,
    PostingFilesCard,
    ValidationApprovalSection,
    TransactionCountCard,
    'eoc-data-points-card': EOCDataPointsCard,
  },
})
export default class RewardsValidation extends Vue {
  fiId!: string;

  selectedCycle: Cycle | null = null;

  cycleHistory: Cycle[] = [];

  loading: number = 0;

  headerItems: any = [{
    text: 'Rewards Processing',
    disabled: false,
    link: false,
  },
  {
    text: 'Rewards Validation',
    disabled: true,
  }];

  currentStep: string = '1';

  cycleValidationSnapshot: CycleValidationSnapshot | null = null;

  validationProducts: ValidationProduct[] = [];

  transactionCounts: CycleTransactionCount[] = [];

  totalTransactionCount: CycleTransactionCount | null = null;

  nonTransactionData: NonTransactionDataSnapshot | null | undefined = null;

  sweepFiles: CycleValidationPostingFile[] = [];

  loadingReport: boolean = false;

  reportMissing: boolean = false;

  hasPostingExceptionReport: boolean = false;

  hasUnapprovedPostingZeroByteFiles: boolean | null = null;

  hasUnapprovedSweepZeroByteFiles: boolean | null = null;

  hasMissingSweepFile: boolean | null = null;

  hasOutOfDateSweepReportFile: boolean | null = false;

  hasOutOfDateReportFile: boolean | null = false;

  firstLoad: boolean = false;

  selectCurrentCycle: boolean = true;

  selectPreviousCycle: boolean = false;

  qualificationsMachineLearningMissing: boolean = false;

  rewardsMachineLearningMissing: boolean = false;

  missingMachineLearningRangesMessage: string = '';

  snapshotVersion: number = 0;

  day1Approval: Approval | null = null;

  day2Approval: Approval | null = null;

  isPostingFileListInitialized: boolean | null = null;

  isSweepFileListInitialized: boolean | null = null;

  @Inject('CycleResource')
  cycleResource!: CycleResource;

  @Inject('RewardsValidationResource')
  rewardsValidationResource!: RewardsValidationResource;

  @Inject('PostingFileResource')
  postingFileResource!: PostingFileResource;

  @Inject('SweepFileResource')
  sweepFileResource!: SweepFileResource;

  @Inject('SnapshotApprovalResource')
  snapshotApprovalResource!: SnapshotApprovalResource;

  @Inject('SweepFileApprovalResource')
  sweepFileApprovalResource!: SweepFileApprovalResource;

  // Make enum visible to template
  CycleApprovalState:any = CycleApprovalState;

  mounted() {
    // When loading data because we've navigated to the page we will drop back to the last cycle if the current one has no data.
    this.firstLoad = true;
  }

  @Watch('selectedCycle')
  async loadData() {
    this.cycleValidationSnapshot = null;
    this.validationProducts = [];
    this.transactionCounts = [];
    this.cycleHistory = [];
    this.totalTransactionCount = null;
    this.nonTransactionData = null;
    this.reportMissing = false;
    this.hasPostingExceptionReport = false;
    this.qualificationsMachineLearningMissing = false;
    this.rewardsMachineLearningMissing = false;
    this.hasUnapprovedPostingZeroByteFiles = null;
    this.hasUnapprovedSweepZeroByteFiles = null;
    this.hasMissingSweepFile = null;
    this.hasOutOfDateReportFile = null;
    this.hasOutOfDateSweepReportFile = null;
    this.sweepFiles = [];
    this.day1Approval = null;
    this.day2Approval = null;
    if (this.selectedCycle) {
      this.loading++;
      this.rewardsValidationResource.getCycleValidationSnapshot(this.fiId, this.selectedCycle.id).then((result: CycleValidationSnapshot) => {
        this.cycleValidationSnapshot = result;

        if (this.cycleValidationSnapshot !== null && (this.cycleValidationSnapshot.approvalState !== CycleApprovalState.GENERATED && this.cycleValidationSnapshot.approvalState !== CycleApprovalState.MANUAL_APPROVAL_REQUIRED)) {
          this.currentStep = '2';
        } else {
          this.currentStep = '1';
        }

        this.parseJSONSnapshot(this.cycleValidationSnapshot.jsonString);
        this.checkForMachineLearningRanges();
      }).catch((error: any) => {
        if (error.response && error.response.status !== 404) {
          this.showErrorMessage(error);
        } else if (this.firstLoad) {
          this.selectCurrentCycle = false;
          this.selectPreviousCycle = true;
          this.firstLoad = false;
        }

        if (error.response && error.response.status === 404) {
          this.currentStep = '1';
        }
      }).finally(() => {
        this.loading--;
        this.firstLoad = false;
      });

      this.getCycleHistory();
      this.checkForPostingExceptionReport();
    }
  }

  checkForPostingExceptionReport() {
    if (this.selectedCycle) {
      this.loading++;
      this.rewardsValidationResource.doesPostingExceptionReportExist(this.fiId, this.selectedCycle.id).then((result: CycleReportExistsResult) => {
        this.hasPostingExceptionReport = result.reportExists;
      }).catch((error: any) => {
        this.showErrorMessage(error);
      }).finally(() => {
        this.loading--;
      });
    }
  }

  parseJSONSnapshot(json: string) {
    this.snapshotVersion = 0;

    // Newer snapshots are instances of ValidationSnapshot.  Older ones are just arrays of ValidationProduct.
    const parsedObj: any = JSON.parse(json);

    if (Array.isArray(parsedObj)) {
      this.validationProducts = parsedObj as ValidationProduct[];
      this.transactionCounts = [];
    } else {
      this.validationProducts = (parsedObj as ValidationSnapshot).validationProducts;
      this.transactionCounts = (parsedObj as ValidationSnapshot).transactionCounts;
      this.nonTransactionData = (parsedObj as ValidationSnapshot).nonTransactionData;

      this.transactionCounts.every((count: CycleTransactionCount) => {
        if (count.transactionType === 'TOTAL_TRANSACTIONS') {
          this.totalTransactionCount = count;
          return false;
        }
        return true;
      });

      if ((parsedObj as ValidationSnapshot).version) {
        this.snapshotVersion = (parsedObj as ValidationSnapshot).version!;
      }
    }
  }

  getCycleHistory() {
    this.cycleResource.getAllCycles(this.fiId).then((allFiCycles: Cycle[]) => {
      this.loading++;
      // Cycles will be in reverse-chronological order, so work back until we find
      // our selected cycle then remember up to five after that.
      const cycleHistory: Cycle[] = [];
      for (let i = 0; i < allFiCycles.length; i++) {
        if (allFiCycles[i].id === this.selectedCycle!.id) {
          for (let x = i + 1; x < allFiCycles.length && x < i + 6; x++) {
            cycleHistory.unshift(allFiCycles[x]);
          }
          cycleHistory.push(this.selectedCycle!);
          break;
        }
      }
      this.cycleHistory = cycleHistory;
    }).catch((error: any) => {
      this.showErrorMessage(error);
    }).finally(() => {
      this.loading--;
    });
  }

  checkForMachineLearningRanges() {
    // If the range fields are present but none are actually populated, then the machine-learning file(s) were likely not found
    // when the snapshot was created, so display an appropriate message.
    this.missingMachineLearningRangesMessage = '';
    if (this.validationProducts
      && this.validationProducts.length > 0
      && !this.validationProducts[0].cycleQualifiers.current.averageYellowThresholdMinimum === undefined) {
      this.qualificationsMachineLearningMissing = true;
      this.rewardsMachineLearningMissing = true;

      // If we find a single qual or reward value that's not null, then we know that it at least tried to populate and will
      // let the individual tables report missing entries.
      for (let i = 0; i < this.validationProducts
        .length; i++) {
        if (this.qualificationsMachineLearningMissing) {
          if (this.validationProducts[i].cycleQualifiers.current.averageYellowThresholdMinimum !== null) {
            this.qualificationsMachineLearningMissing = false;
          } else {
            // Check individual quals
            for (let n = 0; n < this.validationProducts[i].cycleQualifiers.current.qualifiers.length; n++) {
              if (this.validationProducts[i].cycleQualifiers.current.qualifiers[n].yellowThresholdMinimum !== null) {
                this.qualificationsMachineLearningMissing = false;
                break;
              }
            }
          }
        }

        if (this.rewardsMachineLearningMissing && this.validationProducts[i].cycleRewards) {
          // Check individual rewards
          for (let n = 0; n < this.validationProducts[i].cycleRewards!.current.rewards.length; n++) {
            if (this.validationProducts[i].cycleRewards!.current.rewards[n].yellowThresholdMinimum !== null) {
              this.rewardsMachineLearningMissing = false;
              break;
            }
          }
        }

        if (!this.rewardsMachineLearningMissing && !this.qualificationsMachineLearningMissing) {
          break;
        }
      }

      this.formatMachineLearningMissingFileMessage();
    }
  }

  formatMachineLearningMissingFileMessage() {
    if (this.qualificationsMachineLearningMissing || this.rewardsMachineLearningMissing) {
      this.missingMachineLearningRangesMessage = 'The machine learning file';

      if (this.qualificationsMachineLearningMissing && this.rewardsMachineLearningMissing) {
        this.missingMachineLearningRangesMessage += 's';
      }

      this.missingMachineLearningRangesMessage += ' providing valid ranges for ';

      if (this.qualificationsMachineLearningMissing) {
        this.missingMachineLearningRangesMessage += 'qualifications ';
        if (this.rewardsMachineLearningMissing) {
          this.missingMachineLearningRangesMessage += 'and ';
        }
      }

      if (this.rewardsMachineLearningMissing) {
        this.missingMachineLearningRangesMessage += 'rewards ';
      }

      if (this.qualificationsMachineLearningMissing && this.rewardsMachineLearningMissing) {
        this.missingMachineLearningRangesMessage += 'were ';
      } else {
        this.missingMachineLearningRangesMessage += 'was ';
      }

      this.missingMachineLearningRangesMessage += 'not found when generating this snapshot.';
    }
  }

  downloadReport() {
    if (this.selectedCycle) {
      this.loadingReport = true;
      const url = `/api/rcx/director/${this.fiId}/cycle-validation-report/${this.selectedCycle.id}`;
      this.$http.get(url).then(() => {
        window.location.href = url;
      }).catch((error: any) => {
        this.reportMissing = true;
        const dialog = new Dialog('The report you were trying to view does not exist.', 'This may be because processing for that FI has not succeeded for the selected cycle, or this FI has not been white-listed for KRP processing.');
        dialog.setAcceptLabel('OK')
          .setDismissable(false);

        this.$store.dispatch('notices/add', dialog);
      }).finally(() => {
        this.loadingReport = false;
      });
    }
  }

  onPostingZeroByteApprovalStatusChange(hasUnapprovedZeroByteFiles: boolean) {
    this.hasUnapprovedPostingZeroByteFiles = hasUnapprovedZeroByteFiles;
  }

  onSweepZeroByteApprovalStatusChange(hasUnapprovedZeroByteFiles: boolean) {
    this.hasUnapprovedSweepZeroByteFiles = hasUnapprovedZeroByteFiles;
  }

  onLoadedSweepFiles(sweepFiles: CycleValidationPostingFile[], hasMissingFile: boolean) {
    this.sweepFiles = sweepFiles;
    this.hasMissingSweepFile = hasMissingFile;
  }

  onLoadedSweepReportFiles(reportFiles: CycleValidationReportFile[], hasOutOfDateReportFile: boolean) {
    this.isSweepFileListInitialized = true;
  }

  onLoadedPostingReportFiles(reportFiles: CycleValidationReportFile[], hasOutOfDateReportFile: boolean) {
    this.hasOutOfDateReportFile = hasOutOfDateReportFile;
    this.isPostingFileListInitialized = true;
  }

  getDotColor = (approval: Approval | null): string => {
    if (approval && approval.approvalState === CycleApprovalState.APPROVED) {
      return '#479137';
    } if (approval && approval.approvalState === CycleApprovalState.REJECTED) {
      return '#d72027';
    }
    return 'primary';
  }

  getDotIcon = (approval: Approval | null): string | null => {
    if (approval && approval.approvalState === CycleApprovalState.APPROVED) {
      return 'fa-check';
    } if (approval && approval.approvalState === CycleApprovalState.REJECTED) {
      return 'close';
    }
    return null;
  }

  onStepClick(step: string) {
    if (this.currentStep === step) {
      // Have to wait a tick or the default click handler will just open it again.
      this.$nextTick(function () {
        // Collapse the step by changing to one that doesn't exist.
        this.currentStep = '';
      });
    }
  }

  onDay1ApprovalStateChange(approvalState: string, approvalTime: string, approverName: string) {
    this.day1Approval = {
      approvalState,
      approverName,
      approvalTime,
    };

    if (this.day2Approval == null) {
      this.currentStep = '2';
    } else {
      this.currentStep = '';
    }
  }

  onDay2ApprovalStateChange(approvalState: string, approvalTime: string, approverName: string) {
    this.day2Approval = {
      approvalState,
      approverName,
      approvalTime,
    };

    if (this.day1Approval == null) {
      this.currentStep = '1';
    } else {
      this.currentStep = '';
    }
  }

  getApprovalStateDescription = (approval: Approval): string => {
    let description: string = approval.approverName;
    if (approval.approvalState === CycleApprovalState.APPROVED) {
      description += ' approved on ';
    } else {
      description += ' rejected on ';
    }
    description += new Date(approval.approvalTime).toLocaleDateString('en-US', { timeZone: 'America/Chicago' });
    description += ' at ';
    description += new Date(approval.approvalTime).toLocaleTimeString('en-US', { timeZone: 'America/Chicago' });
    description += ' CST';
    return description;
  }

  showErrorMessage(error: string) {
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
